import Layout from "../../../components/layout/layout.js";

import Tickets from "../../../components/ticketsPage";

function TicketsPage({ component, ...rest }) {
  return <Layout Component={Tickets} controlsDisabled={true} {...rest} />;
}

export default TicketsPage;
